import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Kinds from './Kinds';
import Trains from './Trains';
import TrainDetail from './TrainDetail';
import StationDetail from './StationDetail';
import Transfer from './Transfer';
import DelayCertificates from './DelayCertificates';

function App() {
  return (
    <Switch>
      <Route exact path="/trains/kinds.html" component={Kinds} />
      <Route exact path="/lines/mainline/trains" component={Trains} />
      <Route exact path="/lines/mainline/trains/:train_number" component={TrainDetail} />
      <Route exact path="/lines/mainline/stations/:station_id" component={StationDetail} />
      <Route exact path="/lines/mainline/stations/:station_id/transfer" component={Transfer} />
      <Route exact path="/" component={DelayCertificates} />
    </Switch>
  );
}

export default App;
